import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import { commitsCommitResponseSchema } from './common-responses';

export const commitsCommitBodyV20260601Schema = z.object({
  commits: z.array(z.unknown()),
});

/** Runtime-validated loosely; CommitEntityHelpers validates commit shape at persist time. */
export type CommitsCommitBody = {
  commits: readonly unknown[];
};

export class CommitsCommitV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'commits-commit-2026-06-01' as const;

  readonly name = CommitsCommitV20260601Schema.version;
  readonly schema = commitsCommitBodyV20260601Schema;
  readonly response = commitsCommitResponseSchema;
  readonly scopes = ['write', 'commit'] as const;
}

export const COMMITS_API_SCHEMAS = [
  CommitsCommitV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
